import { UseFormStateReturn } from "react-hook-form";
import { GridForm } from "ts/api/task";
import { ErrorCell } from "view/components/GridResponseBlock/CustomizeTable/tools";

export enum GridCellError {
  MaxNumberFiles = "maxFiles",
  MaxFileSize = "fileSize",
  InvalidFileFormat = "fileType",
  Required = "required",
}
const GRID_CELL_ERRORS = Object.values(GridCellError);

const FILE_UPLOAD_ERRORS = [
  GridCellError.MaxNumberFiles,
  GridCellError.MaxFileSize,
  GridCellError.InvalidFileFormat,
];

export const isGridCellError = (errorType: any): errorType is GridCellError =>
  GRID_CELL_ERRORS.includes(errorType);

export const isGridFileUploadError = (
  errorType: any
): errorType is GridCellError => FILE_UPLOAD_ERRORS.includes(errorType);

export const getCurrentCellError = (
  rowIndex: number,
  columnIndex: number,
  errorCells?: ErrorCell[]
) => {
  const error = errorCells?.find(
    ({ columnIndex: errorColumn, rowIndex: errorRow }) =>
      errorColumn === columnIndex && errorRow === rowIndex
  );
  return error && isGridCellError(error.type) ? error.type : null;
};

export const getCellErrors = (
  gridErrors: UseFormStateReturn<GridForm>["errors"]["grid"]
) => {
  const errorCells: ErrorCell[] = [];
  gridErrors?.forEach?.((rowError, rowIndex) => {
    rowError?.cells?.forEach?.((cellError, columnIndex) => {
      if (cellError?.type && isGridCellError(cellError.type)) {
        errorCells.push({ columnIndex, rowIndex, type: cellError.type });
      }
    });
  });
  return errorCells;
};
